
import checkListMeta from '@/mixins/user/meta/checkListMeta'
import { mapState } from 'vuex'
import toolGuard from '@/mixins/user/toolGuard'

export default {
    layout: 'setup',

    mixins: [checkListMeta, toolGuard],

    fetch() {
        this.$store.dispatch('jsonloader/fetchJson', 'setup-checklist.json')
    },

    computed: {
        ...mapState({
            config: (state) => state.jsonloader.data['setup-checklist.json'] || null,
        }),
    },
}
